import React from 'react';
import Show from '../../utility/Show';

const NeighborhoodReports = ({ selectedReport, setSelectedReport, handleMapReport }) => {
  const report = ['Maps', 'Summary'];
  const mapReports = ['Neighborhood Map', 'City Map'];

  return (
    <div className='w-full slide-in-right'>
      <Show>
        <Show.When isTrue={selectedReport !== null}>
          <div className='slide-in-right'>
            {mapReports.map((mapReport, mapReportIndex) => (
              <div
                key={mapReportIndex}
                className="text-lg border-0 border-b border-b-white px-14 py-4 uppercase text-white hover:text-[#ff914d] cursor-pointer"
                onClick={() => handleMapReport(mapReport)}
              >
                {mapReport}
              </div>
            ))}
          </div>
        </Show.When>
        <Show.Else>
          {report.map((item, index) => (
            <div
              className='text-lg border-0 border-b border-b-white px-14 py-4 uppercase text-white hover:text-[#ff914d] cursor-pointer'
              key={index}
              onClick={() => item === 'Maps' ? setSelectedReport(item) : null}
            >
              {item}
            </div>
          ))}
        </Show.Else>
      </Show>
    </div>
  );
};

export default NeighborhoodReports;